import React, { Component } from 'react';
import {
  notification,
  Modal,
  Select,
  Button,
  Row,
  Col,
  InputNumber,
  Input,
} from 'antd/lib';
import _ from 'lodash';
import moment from 'moment';
const Option = Select.Option;
const { TextArea } = Input;
import { withApollo, graphql, compose } from 'react-apollo';

import sancionarContraventor from '../../../graphql/mutations/contravenciones/sancionarContraventor.graphql';
import getConfiguracionPorClave from '../../../graphql/querys/configuracion/getConfiguracionPorClave.graphql';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actionsExpedientes from '../../../actions/expediente';
import * as actionsContraventores from '../../../actions/contraventores';
import * as actionsMain from '../../../actions/main';
import { errorService } from '../../../graphql/utils/utils';

@compose(
  graphql(sancionarContraventor, { name: 'sancionarContraventor' }),
  graphql(getConfiguracionPorClave, {
    name: 'getConfiguracionPorClave',
    options: {
      variables: {
        clave: 'JUS',
      },
    },
  })
)
class ModalSancion extends Component {
  state = {
    tipoSancion: 'MULTA',
    articulosParaSancionar: [],
    cantidadJus: 0,
    montoSancion: 0,
    montoAdicional: 0,
    cantidadDias: 0,
    observacion: '',
  };

  onChangeTipoSancion = value => {
    this.setState({
      tipoSancion: value,
      cantidadJus: 0,
      montoSancion: 0,
      montoAdicional: 0,
      cantidadDias: 0,
      observacion: '',
    });
  };

  onChangeCantidadDias = value => {
    this.setState({ cantidadDias: value });
  };

  onChangeObservacion = e => {
    this.setState({ observacion: e.target.value });
  };

  crearOpciones = articulo => {
    return (
      <Option key={articulo._id} value={articulo._id}>
        {articulo.nombre}
      </Option>
    );
  };

  handleChange = e => {
    // console.log('CAMBIOS EN EL SELECT');
    // console.log(e);
    // console.log(this.props.contraventor);
    this.setState({
      articulosParaSancionar: e,
    });
  };

  onChange = value => {
    // console.log('JUS', this.props.getConfiguracionPorClave.getConfiguracionPorClave);
    let jus = this.props.getConfiguracionPorClave.getConfiguracionPorClave;
    let valor = value ? value : 0;
    let monto = valor * jus.valor + this.state.montoAdicional;
    this.setState({
      cantidadJus: value,
      montoSancion: Math.round(monto),
    });
  };

  onChangeMontoAdicional = value => {
    let jus = this.props.getConfiguracionPorClave.getConfiguracionPorClave;
    let valor = this.state.cantidadJus ? this.state.cantidadJus : 0;
    let monto = valor * jus.valor + value;
    this.setState({
      montoAdicional: value,
      montoSancion: Math.round(monto),
    });
  };

  // esta funcion se encarga segun del tipo seleccionado que los campos esten completos
  validarCamposRequeridos = () => {
    const { tipoSancion, cantidadJus, cantidadDias, observacion } = this.state;
    if (
      (tipoSancion === 'MULTA' && cantidadJus === 0) ||
      (tipoSancion === 'ARRESTO' && cantidadDias === 0) ||
      (tipoSancion !== 'MULTA' && observacion === '')
    ) {
      return false;
    }
    return true;
  };

  // eslint-disable-next-line no-unused-vars
  handleOk = e => {
    const camposValidos = this.validarCamposRequeridos();

    if (camposValidos) {
      let sancion = {
        idArticulos: this.state.articulosParaSancionar,
        tipoSancion: this.state.tipoSancion,
        monto: this.state.montoSancion,
        cantidadJus: this.state.cantidadJus,
        montoAdicional: this.state.montoAdicional,
        cantidadDias: this.state.cantidadDias,
        observacion: this.state.observacion,
        fechaSancion: moment().toDate(),
        fechaPrescripcion: moment()
          .add(1, 'Y')
          .toDate(),
      };

      this.props
        .sancionarContraventor({
          variables: {
            _id: this.props.contraventor._id,
            sancion: sancion,
          },
        })
        .then(res => {
          // console.log('Recibi...');
          // console.log(res);

          if (res.data.sancionarContraventor) {
            this.props.actionsExpedientes.actualizarContraventor(
              res.data.sancionarContraventor
            );

            notification.success({
              message: 'Contraventor Sancionado Correctamente',
              description: 'La sancion generada fue aplicada al contraventor.',
              placement: 'bottomRight',
            });

            this.props.ocultarModalSancion();
          }
        })
        .catch(err => {
          console.log('ERROR');
          console.log(err);
          errorService(err, {
            _id: this.props.contraventor._id,
            sancion: sancion,
          });
          Modal.error({
            title: 'Error a la hora de emitir la sancion',
            content:
              'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
          });
        });
    } else {
      notification.warning({
        message: 'Complete todos los campos',
        description: 'Debe llenar todos los campos antes de continuar',
        placement: 'bottomRight',
      });
    }
  };

  render() {
    let opcionesTipoSancion = [
      { value: 'MULTA', label: 'MULTA' },
      { value: 'ARRESTO', label: 'ARRESTO' },
      { value: 'TRABAJO COMUNITARIO', label: 'TRABAJO COMUNITARIO' },
      { value: 'OTRO', label: 'OTRO' },
    ];

    let opciones = [];
    if (this.props.articulos) {
      // console.log('ME LLEGO: ');
      // console.log(this.props.articulos);
      opciones = _.map(this.props.articulos, this.crearOpciones);
    }

    // console.log('PROPS');
    // console.log(this.props);
    let jus = this.props.getConfiguracionPorClave.getConfiguracionPorClave
      ? this.props.getConfiguracionPorClave.getConfiguracionPorClave.valor
      : 0;

    // console.log('EL JUS: ', jus);
    // console.log('MONTO: ', this.state.montoSancion);
    return (
      <div>
        <Modal
          title="Emitir Sancion"
          visible={this.props.visibleSancion}
          onCancel={this.props.ocultarModalSancion}
          onOk={this.handleOk}
          width={800}
          style={{ width: 600 }}
          footer={[
            <Button key="back" onClick={this.props.ocultarModalSancion}>
              Volver
            </Button>,
            <Button
              style={{ marginLeft: 5 }}
              key="sancionar"
              type="danger"
              onClick={this.handleOk}
            >
              Sancionar
            </Button>,
          ]}
        >
          <Row>
            <Col span={8}>
              <h3>Tipo Sancion: </h3>
            </Col>
            <Col span={6}>
              <Select
                style={{ width: '200px' }}
                defaultValue={this.state.tipoSancion}
                onChange={this.onChangeTipoSancion}
                options={opcionesTipoSancion}
              />
            </Col>
          </Row>
          <Row style={{ marginTop: 10 }}>
            <Col span={8}>
              <h3>Seleccionar Articulos: </h3>
            </Col>
            <Select
              showSearch
              mode="multiple"
              style={{ width: 400 }}
              placeholder="Seleccione los articulos para sancionar"
              optionFilterProp="children"
              onChange={this.handleChange}
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              {opciones}
            </Select>
          </Row>
          {this.state.tipoSancion === 'MULTA' && (
            <>
              <Row style={{ marginTop: 10 }}>
                <Col span={8}>
                  <h3>Cantidad de JUS: </h3>
                </Col>
                <Col span={3}>
                  <InputNumber
                    defaultValue={0}
                    min={0}
                    max={10}
                    step={0.1}
                    onChange={this.onChange}
                  />
                </Col>
                <Col span={3} offset={1}>
                  JUS: {jus}
                </Col>

                <Col span={5} offset={1}>
                  Monto Sancion: ${this.state.montoSancion}
                </Col>
              </Row>
              <Row style={{ marginTop: 10 }}>
                <Col span={8}>
                  <h3>Monto Adicional: </h3>
                </Col>
                <Col span={4}>
                  <InputNumber
                    defaultValue={0}
                    formatter={value => `$ ${value}`}
                    min={0}
                    max={5000}
                    step={50}
                    onChange={this.onChangeMontoAdicional}
                  />
                </Col>
              </Row>
            </>
          )}
          {this.state.tipoSancion === 'ARRESTO' && (
            <>
              <Row style={{ marginTop: 10 }}>
                <Col span={8}>
                  <h3>Cantidad de dias: </h3>
                </Col>
                <Col span={4}>
                  <InputNumber min={0} onChange={this.onChangeCantidadDias} />
                </Col>
              </Row>
            </>
          )}
          {/* ARRESTO, TRABAJO COMUNITARIO y OTRO  usan campo observacion */}
          {this.state.tipoSancion !== 'MULTA' && (
            <>
              <Row style={{ marginTop: 10 }}>
                <Col span={8}>
                  <h3>Observaciones:</h3>
                </Col>
                <Col>
                  <TextArea
                    style={{ width: 400 }}
                    rows={3}
                    value={this.state.observacion}
                    placeholder="Observaciones"
                    onChange={this.onChangeObservacion}
                  />
                </Col>
              </Row>
            </>
          )}
        </Modal>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  actionsExpedientes: bindActionCreators(actionsExpedientes, dispatch),
  actionsContraventores: bindActionCreators(actionsContraventores, dispatch),
  actionsMain: bindActionCreators(actionsMain, dispatch),
});

function mapStateToProps(state) {
  // console.log('mapStateToPorps: ', state);
  return state;
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withApollo(ModalSancion));
